import React, { useState } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import SportsSoccerRoundedIcon from '@mui/icons-material/SportsSoccerRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ThumbUpRoundedIcon from '@mui/icons-material/ThumbUpRounded';
import ThumbDownRoundedIcon from '@mui/icons-material/ThumbDownRounded';
import tokens from '../theme/tokens';

const VERDE = '#10B981';
const VERMELHO = '#EF4444';

const rotulo = {
  '& .MuiSpeedDialAction-staticTooltipLabel': {
    bgcolor: '#fff',
    color: tokens.color.text,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    boxShadow: tokens.shadow.md,
    borderRadius: 2,
  },
};

/**
 * Botão flutuante (Speed Dial) de presença na pelada aberta: "Eu vou!" e "Não vou".
 * `status`: 'confirmado' | 'recusou' | 'chegou' | 'indefinido'.
 */
const PresencaFab = ({ status, onEuVou, onNaoVou, carregando }) => {
  const [aberto, setAberto] = useState(false);
  const chegou = status === 'chegou';

  const executar = async (acao) => {
    setAberto(false);
    await acao();
  };

  return (
    <>
      <Backdrop open={aberto} onClick={() => setAberto(false)} sx={{ zIndex: 1250, bgcolor: 'rgba(14,17,22,0.35)' }} />
      <SpeedDial
        ariaLabel="Confirmar presença na pelada"
        open={aberto}
        onClick={() => !carregando && setAberto((v) => !v)}
        onClose={(e, motivo) => motivo !== 'toggle' && motivo !== 'mouseLeave' && setAberto(false)}
        icon={
          carregando ? (
            <CircularProgress size={26} sx={{ color: '#fff' }} />
          ) : (
            <Box component="span" sx={{ display: 'grid', placeItems: 'center', transition: 'transform .25s', transform: aberto ? 'rotate(90deg)' : 'none' }}>
              {aberto ? <CloseRoundedIcon /> : <SportsSoccerRoundedIcon sx={{ fontSize: 32 }} />}
            </Box>
          )
        }
        FabProps={{
          sx: {
            width: 64,
            height: 64,
            bgcolor: status === 'confirmado' || chegou ? VERDE : status === 'recusou' ? VERMELHO : tokens.color.ink,
            '&:hover': { bgcolor: status === 'confirmado' || chegou ? '#0E9F70' : status === 'recusou' ? '#DC2626' : tokens.color.inkSoft },
            boxShadow: tokens.shadow.lg,
          },
        }}
        sx={{ position: 'fixed', bottom: { xs: 'calc(80px + env(safe-area-inset-bottom))', md: 28 }, right: { xs: 16, sm: 28 }, zIndex: 1300 }}
      >
        <SpeedDialAction
          icon={<ThumbDownRoundedIcon />}
          tooltipTitle={status === 'recusou' ? 'Não vou ✓' : 'Não vou'}
          tooltipOpen
          onClick={(e) => {
            e.stopPropagation();
            if (!chegou) executar(onNaoVou);
          }}
          FabProps={{ disabled: chegou, sx: { bgcolor: VERMELHO, color: '#fff', '&:hover': { bgcolor: '#DC2626' }, '&.Mui-disabled': { bgcolor: '#FCA5A5', color: '#fff' } } }}
          sx={rotulo}
        />
        <SpeedDialAction
          icon={<ThumbUpRoundedIcon />}
          tooltipTitle={status === 'confirmado' || chegou ? 'Eu vou! ✓' : 'Eu vou!'}
          tooltipOpen
          onClick={(e) => {
            e.stopPropagation();
            if (!chegou) executar(onEuVou);
          }}
          FabProps={{ disabled: chegou, sx: { bgcolor: VERDE, color: '#fff', '&:hover': { bgcolor: '#0E9F70' }, '&.Mui-disabled': { bgcolor: '#6EE7B7', color: '#fff' } } }}
          sx={rotulo}
        />
      </SpeedDial>
    </>
  );
};

export default PresencaFab;
